/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form, TextArea } from 'semantic-ui-react'

export default class DealEndMessage extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    return (
      <Form.Field
        control={TextArea}
        value={value}
        label="Deal End Message"
        onChange={e => onChange(e.target.value)}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/specialDeal/fields/DealEndField.js